import React from "react";
import PageHeader, { PageCTA } from "../components/PageHeader";
import WhyMe from "../components/WhyMe";

export default function WhyMePage() {
  return (
    <div data-testid="page-dlaczego-ja">
      <PageHeader
        eyebrow="Dlaczego ja"
        title={
          <>
            Dlaczego warto ze mną{" "}
            <span className="gold-gradient-text italic">pracować</span>
          </>
        }
        subtitle="Cztery powody, dla których właściciele firm transportowych wybierają współpracę ze mną zamiast klasycznego doradztwa."
      />
      <WhyMe />
      <PageCTA
        title="Sprawdźmy, czy jesteśmy dla siebie."
        text="Krótka rozmowa wystarczy, żeby zobaczyć, czy moje podejście pasuje do Twoich potrzeb."
        buttonLabel="Umów rozmowę"
        to="/kontakt"
      />
    </div>
  );
}
